import HttpStatus from 'http-status-codes';
import stringify from 'fast-safe-stringify';
import constants from '../config/constants';

/** @type {(key: string, value: any) => any} */
function replacer(_, value) {
    return value === undefined ? '<undefined>' : value;
}

/**
 * @param {import('axios').AxiosRequestConfig} config
 * @return {import('axios').AxiosRequestConfig}
 */
export function requestHandler(config) {
    if (constants.LOG_AXIOS) {
        // @ts-ignore
        config.requestStart = Date.now();
    }
    return config;
}

/**
 * @param {import('axios').AxiosResponse} response
 * @param {'SERVER' | 'CLIENT' | 'API'} source
 */
export function responseHandler(response, source) {
    if (constants.LOG_AXIOS) {
        const { config } = response;
        // @ts-ignore
        const { requestStart } = config;
        if (requestStart) {
            // eslint-disable-next-line no-console
            console.info(`AXIOS ${source} [${Date.now() - requestStart}ms] ${config.method?.toUpperCase()} ${config.url}`);
        }
    }
    return response;
}

/**
 * @param {import('axios').AxiosError} error
 * @param {'SERVER' | 'CLIENT' | 'API'} source
 * @param {import('@sentry/minimal') | import('@sentry/node')} sentry
 */
export function errorHandler(error, source, sentry) {
    const { config, response } = error;
    const { status, data } = response || {};
    /** @type {string} */
    let dataTrimmed;

    if (typeof(data) === 'string' && data.length > 1000) {
        dataTrimmed = data.substr(0, 1000) + '[...]';
    } else {
        dataTrimmed = stringify(data, replacer, 2);
    }

    if (constants.IS_DEVELOPMENT) {
        if (status !== HttpStatus.NOT_FOUND || !config.url?.includes('/userdata/')) {
            console.error({
                axiosError: `[${source}] ${error.toString()}`,
                status,
                responseDataTrimmed: dataTrimmed,
                requestConfig: config,
            });
        }
    }

    sentry.configureScope(scope => {
        scope.setExtra('responseDataTrimmed', dataTrimmed);
        scope.setTags({
            axiosUrl: config.url,
            axiosStatus: status,
        });
        scope.setFingerprint([
            '{{ default }}',
            String(config.url),
            String(status),
        ]);
    });
}
